import goalSettingsStepsSchema from './GoalSettings/stepsSchemaPl';
import dietSettingsStepsSchema from './DietSettings/stepsSchemaPl';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';
import packageJson from '../package.json';
export const ALLOWED_LANGUAGES = ['pl-PL', 'en-US'];

export const SENTRY_DSN =
  'https://1d051fae1e65d2042ed142c975ef3125@o251048.ingest.us.sentry.io/4509388266799105';

export const APP_STORE_URL = 'https://download.trainingbyann.com/17FA/jq3ju6k6';
export const GOOGLE_PLAY_URL = 'https://download.trainingbyann.com/17FA/jq3ju6k6';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'dtba';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://dieta.hpba.pl/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'dtba',
  name: 'dtba',
  themeColor: '#ffffff',
  title: 'Diet & Training by Ann',
  description: '',
  keywords: ['dtba'],
  author: 'activerse.app',
};

export const FRISCO = true;
export const INSTACART_FIREBASE_FUNCTION = 'https://dtbainstacartgenerator-q6ve2zz6jq-uc.a.run.app';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;

export const FORCE_BUILD = false;

export const OPEN_APP_URL = 'https://download.trainingbyann.com/17FA/zvxdi4a4';
